/*!
 *
 *  Copyright (c) "Neo4j"
 *  Neo4j Sweden AB [http://neo4j.com]
 *
 *  This file is part of Neo4j.
 *
 *  Neo4j is free software: you can redistribute it and/or modify
 *  it under the terms of the GNU General Public License as published by
 *  the Free Software Foundation, either version 3 of the License, or
 *  (at your option) any later version.
 *
 *  This program is distributed in the hope that it will be useful,
 *  but WITHOUT ANY WARRANTY; without even the implied warranty of
 *  MERCHANTABILITY or FITNESS FOR A PARTICULAR PURPOSE.  See the
 *  GNU General Public License for more details.
 *
 *  You should have received a copy of the GNU General Public License
 *  along with this program.  If not, see <http://www.gnu.org/licenses/>.
 */

import '@neo4j-ndl/base/lib/neo4j-ds-styles.css';

import { Combobox } from '@neo4j-ndl/react';
import { useState } from 'react';

type Option = {
  label: string;
  value: string;
};

const INITIAL_OPTIONS: Option[] = [
  { label: 'Recommendations', value: 'recommendations' },
  { label: 'Fraud detection', value: 'fraud-detection' },
  { label: 'Knowledge graph', value: 'knowledge-graph' },
];

const Component = () => {
  const [options, setOptions] = useState(INITIAL_OPTIONS);
  const [value, setValue] = useState<Option[]>([]);

  return (
    <Combobox
      label="Use cases"
      placeholder="Select use cases"
      searchPlaceholder="Search or add a use case"
      isMulti
      isCreatable
      isClearable
      options={options}
      value={value}
      onChange={(nextValue) => setValue(nextValue)}
      // Created options are not added to `options` by the Combobox, so they are
      // appended here to keep them available for later selections.
      onCreateOption={(option) => setOptions((current) => [...current, option])}
    />
  );
};

export default Component;
